import React from 'react';
import { connect } from 'react-redux';
import ObservationPage from './ObservationPage';
import { observationCodes } from './ObservationPage';
import { filterObservationResults } from './LabsPage';
import {
    PATH_LABS_PSA,
    PATH_LABS_TESTOSTERONE,
    PATH_LABS_HCG,
    PATH_LABS_AFP,
    PATH_LABS_LDH,
    PATH_LABS_FSH,
    PATH_LABS_LH,
} from '../../../src/containers/RoutePaths';
import { useLocation } from 'react-router-dom';
import LoadingErrorPage from '../LoadingErrorPage';

const LabResultsPage = ({ observationResults }) => {
    const location = useLocation();

    switch (location.pathname) {
        case PATH_LABS_PSA:
            return (
                <ObservationPage
                    observationCode={observationCodes.PSA}
                    observationResults={filterObservationResults(observationResults, observationCodes.PSA.code)}
                />
            );
        case PATH_LABS_TESTOSTERONE:
            return (
                <ObservationPage
                    observationCode={observationCodes.Testosterone}
                    observationResults={filterObservationResults(observationResults, observationCodes.Testosterone.code)}
                />
            );
        case PATH_LABS_HCG:
            return (
                <ObservationPage
                    observationCode={observationCodes.HCG}
                    observationResults={filterObservationResults(observationResults, observationCodes.HCG.code)}
                />
            );
        case PATH_LABS_AFP:
            return (
                <ObservationPage
                    observationCode={observationCodes.AFP}
                    observationResults={filterObservationResults(observationResults, observationCodes.AFP.code)}
                />
            );
        case PATH_LABS_LDH:
            return (
                <ObservationPage
                    observationCode={observationCodes.LDH}
                    observationResults={filterObservationResults(observationResults, observationCodes.LDH.code)}
                />
            );
        case PATH_LABS_FSH:
            return (
                <ObservationPage
                    observationCode={observationCodes.FSH}
                    observationResults={filterObservationResults(observationResults, observationCodes.FSH.code)}
                />
            );
        case PATH_LABS_LH:
            return (
                <ObservationPage
                    observationCode={observationCodes.LH}
                    observationResults={filterObservationResults(observationResults, observationCodes.LH.code)}
                />
            );
        default:
            return <LoadingErrorPage />;
    }
};

/** Hooking up to redux store **/
function mapStateToProps(state) {
    return {
        observationResults: state.observation.labResults,
    };
}

export default connect(mapStateToProps, null)(LabResultsPage);
